import _ from 'lodash'
import * as React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useFormikContext } from 'formik' // 🔧 FIX: Importar useFormikContext
import { Autocomplete as AutocompleteMUI } from '@mui/material'
import {
  setEnableSectionField,
  setEnableSiteField,
  setEnableAcronymField,
} from '../../redux/slices/Tree/treeFeatures'
import { getSitesDataByName } from '../../services'
import Textfield from '../FormsUI/Textfield'

const MSJ_ERROR = { error: true, helperText: 'Obligatorio' }

const InputGroup2 = ({ name, options, editable, ...rest }) => {
  const dispatch = useDispatch()

  const { setFieldValue, values } = useFormikContext()
  const latestValueRef = React.useRef(values?.[name])

  const optionsListInitial = React.useMemo(() => {
    const uniqueLabels = new Set()
    return _.map(options, (label, index) => ({ id: `${label}_${index}`, label })).filter(
      option => {
        if (uniqueLabels.has(option.label)) {
          return false
        }
        uniqueLabels.add(option.label)
        return true
      }
    )
  }, [options])

  const idInitValue = _.findIndex(optionsListInitial, 'selectedInitial')
  const [optionsList, setOptionsList] = React.useState(optionsListInitial)
  const [filterList1, setSelectedList] = React.useState({
    id: idInitValue >= 0 ? optionsListInitial[idInitValue].id : null,
    label: rest.initvalue ?? '',
  })

  const siteSelected = useSelector(
    state => state.treeFeatures.enableSaveButton.siteField?.selected
  )

  const fields = useSelector(state => state.treeFeatures.enableSaveButton)
  const { siteField, siteAcronym, sectionField } = fields
  const infoError = {
    site_: siteField,
    section_: sectionField,
    siteAcronym_: siteAcronym,
  }

  const handleSelection = (event, newList) => {
    let label = newList?.label || ''
    if (name === 'siteAcronym_') label = label.toUpperCase().slice(0, 4)
    const updatedList = newList ? { ...newList, label } : newList
    setSelectedList(updatedList)
    setFieldValue(name, label)

    const newObject = !Boolean(label)
      ? MSJ_ERROR
      : { error: false, selected: label }
    if (name === 'site_') dispatch(setEnableSiteField(newObject))
    if (name === 'section_') dispatch(setEnableSectionField(newObject))
    if (name === 'siteAcronym_') dispatch(setEnableAcronymField(newObject))
  }

  const handleOnBlur = () => {
    if (name === 'site_')
      if (!siteField.error && !Boolean(siteField?.selected?.length))
        dispatch(setEnableSiteField(MSJ_ERROR))
    if (name === 'section_')
      if (!sectionField.error && !Boolean(sectionField?.selected?.length))
        dispatch(setEnableSectionField(MSJ_ERROR))
    if (name === 'siteAcronym_')
      if (!siteAcronym.error && !Boolean(siteAcronym?.selected?.length))
        dispatch(setEnableAcronymField(MSJ_ERROR))
  }

  const handleOnInputChange = (e, value) => {
    let processedValue = value || ''
    if (name === 'siteAcronym_') {
      processedValue = processedValue.toUpperCase().slice(0, 4)
    }
    setFieldValue(name, processedValue)

    let newObject = !Boolean(processedValue) ? MSJ_ERROR : { error: false, selected: processedValue }
    if (name === 'site_') dispatch(setEnableSiteField(newObject))
    if (name === 'section_') dispatch(setEnableSectionField(newObject))
    if (name === 'siteAcronym_') dispatch(setEnableAcronymField(newObject))
  }

  const othersProps = {
    name,
    value: values[name] || filterList1?.label || '',
    label: rest.label,
    variant: 'standard',
    size: 'small',
    error: infoError?.[name]?.error,
    helperText: infoError?.[name]?.helperText,
    ...(name === 'siteAcronym_' && {
      placeholder: 'Ej: BLTE',
    }),
  }

  React.useEffect(() => {
    if (!values?.[name] && rest.initvalue) {
      setFieldValue(name, rest.initvalue)
    }
  }, [values?.[name], rest.initvalue, name, setFieldValue])

  React.useEffect(() => {
    latestValueRef.current = values?.[name]
  }, [values?.[name], name])

  React.useEffect(() => {
    return () => {
      const MSJ_DEFAULT = { error: false, selected: null }
      const obj = {
        site_: setEnableSiteField(MSJ_DEFAULT),
        section_: setEnableSectionField(MSJ_DEFAULT),
        siteAcronym_: setEnableAcronymField(MSJ_DEFAULT),
      }
      if (!latestValueRef.current) {
        dispatch(obj[name])
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  React.useEffect(() => {
    if (name === 'site_') return
    if (!Boolean(siteSelected)) return
    const fieldName = name === 'section_' ? 'seccion' : 'acronimoSitio'
    getSitesDataByName(siteSelected, fieldName)
      .then(filteredOptions => {
        const uniqueLabels = new Set()
        const uniqueOptions = filteredOptions.filter(option => {
          if (uniqueLabels.has(option.label)) {
            return false
          }
          uniqueLabels.add(option.label)
          return true
        })

        setOptionsList(uniqueOptions)
      })
      .catch(err => console.log('Error :>> ', err))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [siteSelected])

  React.useEffect(() => {
    if (values[name] && values[name] !== filterList1?.label) {
      setSelectedList({
        id: null,
        label: values[name],
      })
    }
  }, [values[name], name])

  return (
    <AutocompleteMUI
      freeSolo
      id={`free-solo-${name}`}
      name={name}
      value={filterList1}
      onChange={handleSelection}
      onInputChange={handleOnInputChange}
      options={optionsList}
      onBlur={handleOnBlur}
      readOnly={!editable}
      getOptionLabel={option => option.label || ''}
      isOptionEqualToValue={(option, value) =>
        option.label === value.label || option.id === value.id
      }
      renderInput={params => {
        const mergedInputProps = name === 'siteAcronym_'
          ? { ...params.inputProps, maxLength: 4, style: { ...params.inputProps?.style, textTransform: 'uppercase' } }
          : params.inputProps
        return <Textfield {...params} {...othersProps} inputProps={mergedInputProps} />
      }}
    />
  )
}

export default React.memo(InputGroup2)
